module.exports = __webpack_public_path__ + "img/logo-gray-sevdesk.6e867bf2.png";